import { api } from './customers'

export interface MedicineMaster {
    id: number;
    medicineName:string;
    medicineType:string;
    medicineDose:string;
    manufacturing:string;
    activeStatus:string;
    customerId: number

}

type MedicineMastersResponse = MedicineMaster[];

export const MedicineMasterApi = api.injectEndpoints({
    endpoints: (build) => ({

        getMedicineMasters: build.query<MedicineMastersResponse, any>({
            query: ({ pageNo, name }) =>
                `medicine_master?page=${pageNo}&filter=${name}`,
        }),
        addMedicineMaster: build.mutation<any, Partial<any>>({
            query: (body: any) => ({
                url: `medicine_master`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: MedicineMaster }, meta, arg) => response.data,
        }),
        getMedicineMaster: build.query<MedicineMaster, string>({
            query: (id) => `medicine_master/${id}`,
            transformResponse: (response: { data: MedicineMaster }, meta, arg) => response.data,
        }),
        // Get Medicine master List
    getNewMedicineList: build.query<any, void>({
      query: () => `new-medicine-master-list`, 
    }),
        updateMedicineMaster: build.mutation<void, Pick<MedicineMaster, 'id'> & Partial<MedicineMaster>>({
            query: ({ id, ...patch }) => ({
                url: `medicine_master/${id}`,
                method: 'PUT',
                body:patch,
            }),
        }),
        deleteMedicineMaster: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `medicine_master/${id}`,
                    method: 'DELETE',
                }
            },
        }),
    }),
})

export const {
    useGetMedicineMasterQuery,
    useGetMedicineMastersQuery,
    useGetNewMedicineListQuery,
    useAddMedicineMasterMutation,
    useUpdateMedicineMasterMutation,
    useDeleteMedicineMasterMutation,
} = MedicineMasterApi;
